import axios from 'axios';

import { currentBrand, fesApiBaseUrl, integrationApiBaseUrl } from 'config';

const brandPathPrefix = process.env.NODE_ENV === 'production' ? `/${currentBrand}` : '';

export const CpDataApi = axios.create({
    baseURL: integrationApiBaseUrl,
});

export const CpFesApi = axios.create({
    baseURL: fesApiBaseUrl,
});

export const CpContentApi = axios.create({
    baseURL: `${brandPathPrefix}/contents`,
    headers: {
        'X-CP-Brand': currentBrand,
    },
});
